import script from "./Send.vue?vue&type=script&setup=true&lang=js"
export * from "./Send.vue?vue&type=script&setup=true&lang=js"

import "./Send.vue?vue&type=style&index=0&id=a616cc88&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a616cc88"]])

export default __exports__